import React from 'react';

import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';

import { PROJECT_PREFIX } from '../const';

function NewEntityButton({ to }) {
    return (
        <Button
            component={Link}
            to={`${PROJECT_PREFIX}${to}`}
            variant="outline"
        >
            Добавить
        </Button>
    );
}

export default NewEntityButton;
